module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-06.e229cae3.jpg";